import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {SteelProfileService} from './steel-profile.service';
import {ProfileTypeService} from './profile-type.service';
import {SteelProfileRoutingModule} from './steel-profile-routing.module';
import {SteelProfileListComponent} from './steel-profile-list/steel-profile-list.component';
import {SteelProfileDetailsComponent} from './steel-profile-details/steel-profile-details.component';
import {ProfileCommonFormComponent} from './steel-profile-forms/profile-common-form/profile-common-form.component';
import {SteelProfileFormDirective} from './steel-profile-forms/steel-profile-form.directive';
import {SteelProfileFormSelectorComponent} from './steel-profile-forms/steel-profile-form-selector/steel-profile-form-selector.component';
import {FrameProfileFormComponent} from './steel-profile-forms/frame-profile-form/frame-profile-form.component';
import {PurlinProfileFormComponent} from './steel-profile-forms/purlin-profile-form/purlin-profile-form.component';
import {EaveStrutProfileFormComponent} from './steel-profile-forms/eave-strut-profile-form/eave-strut-profile-form.component';
import {TubestFormComponent} from './steel-profile-forms/tubest-form/tubest-form.component';
import {TubestCFormComponent} from './steel-profile-forms/tubest-c-form/tubest-c-form.component';
import {ZTubestFormComponent} from './steel-profile-forms/z-tubest-form/z-tubest-form.component';
import {SquaredProfileFormComponent} from './steel-profile-forms/squared-profile-form/squared-profile-form.component';
import {RectangularProfileFormComponent} from './steel-profile-forms/rectangular-profile-form/rectangular-profile-form.component';
import {CintacPurlinFormComponent} from './steel-profile-forms/cintac-purlin-form/cintac-purlin-form.component';
import { SteelProfileCreateComponent } from './steel-profile-create/steel-profile-create.component';
import { ProfileTypeCreateComponent } from './profile-type-create/profile-type-create.component';
import { ProfileTypeDetailComponent } from './profile-type-detail/profile-type-detail.component';


@NgModule({
    imports: [
        SteelProfileRoutingModule,
        ReactiveFormsModule,
        CommonModule,
        FormsModule
    ],
    exports: [],
    declarations: [
        SteelProfileListComponent,
        SteelProfileDetailsComponent,
        ProfileCommonFormComponent,
        SteelProfileFormDirective,
        SteelProfileFormSelectorComponent,
        FrameProfileFormComponent,
        PurlinProfileFormComponent,
        EaveStrutProfileFormComponent,
        TubestFormComponent,
        TubestCFormComponent,
        ZTubestFormComponent,
        SquaredProfileFormComponent,
        RectangularProfileFormComponent,
        CintacPurlinFormComponent,
        SteelProfileCreateComponent,
        ProfileTypeCreateComponent,
        ProfileTypeDetailComponent,
    ],
    providers: [SteelProfileService, ProfileTypeService],
    entryComponents: [TubestFormComponent, TubestCFormComponent, ZTubestFormComponent,
        SquaredProfileFormComponent, RectangularProfileFormComponent, CintacPurlinFormComponent,
        FrameProfileFormComponent, PurlinProfileFormComponent, EaveStrutProfileFormComponent]
})
export class SteelProfileModule {
}



// WEBPACK FOOTER //
// ./src/app/steel-profile/steel-profile.module.ts